import React, {useRef, useState} from "react"
import productPageImg from "../../../../../assets/website-images/product/bio-page-banner.png"
import productBannerImg from "../../../../../assets/website-images/product/product-banner.jpg";
import {useInView} from "framer-motion";
import "./bio.scss"
import PageBanner from "../../../../components/website/pages-banner/PageBanner";
import {Col, Container, Row} from "react-bootstrap";
import box1Img from "../../../../../assets/website-images/product/bio/sec-1-box.png";
import box2Img from "../../../../../assets/website-images/product/bio/sec-1-box2.png";
import box3Img from "../../../../../assets/website-images/product/bio/sec-1-box3.png";
import box4Img from "../../../../../assets/website-images/product/bio/sec-1-box4.png";
import box5Img from "../../../../../assets/website-images/product/bio/sec-1-box5.png";
import box6Img from "../../../../../assets/website-images/product/bio/sec-1-box6.png";
import sec2Img from "../../../../../assets/website-images/product/bio/sec2/img1.png";
import sec2Img2 from "../../../../../assets/website-images/product/bio/sec2/img2.png";
import sec3Img from "../../../../../assets/website-images/product/bio/sec3/sec3Img.png";
import sec4Img from "../../../../../assets/website-images/product/bio/sec3/sec4Img.png";
import {useTranslation} from "react-i18next";


export default function Product() {
    const {t} = useTranslation();
    const ref3 = useRef(null);
    const ref = useRef(null);
    const isInView3 = useInView(ref3, { once: true });
    const isInView = useInView(ref, { once: true }); // Only trigger once
    const [activeSection, setActiveSection] = useState(1);
    const containerVariants2 = {
        hidden: { opacity: 1 },
        show: {
            opacity: 1,
            transition: {
                staggerChildren: 0.3, // Staggering the animation of each child by 0.3 seconds
            },
        },
    };
    const cardVariants = {
        hidden: { opacity: 0, x: -100 }, // Start with opacity 0 and 100px to the left
        show: { opacity: 1, x: 0 },      // Fade in and move to original position
    };


    const handleSectionClick = (sectionIndex) => {
        setActiveSection(sectionIndex);
    };

    return(
        <div className={'bio-page'}>
            <PageBanner img={productPageImg} heading={t('products.biomatric_sdk.banner_head')} bannerImg={productBannerImg}/>
            <div className={'bio-list'}>
                <Container>
                    <Row>
                        <Col md={12}>
                            <h2 className={'heading'}>{t('products.biomatric_sdk.banner_head')}</h2>
                            <ul>
                                <li
                                    className={activeSection === 1 ? 'active' : ''}
                                    onClick={() => handleSectionClick(1)}
                                >
                                    {t('products.biomatric_sdk.head_1')}
                                </li>
                                <li
                                    className={activeSection === 2 ? 'active' : ''}
                                    onClick={() => handleSectionClick(2)}
                                >
                                    {t('products.biomatric_sdk.head_2')}
                                </li>
                                <li
                                    className={activeSection === 3 ? 'active' : ''}
                                    onClick={() => handleSectionClick(3)}
                                >
                                    {t('products.biomatric_sdk.head_3')}
                                </li>
                                <li
                                    className={activeSection === 4 ? 'active' : ''}
                                    onClick={() => handleSectionClick(4)}
                                >
                                    {t('products.biomatric_sdk.head_4')}
                                </li>
                            </ul>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className={activeSection === 1 ? 'section-1' : 'section-1 hide'}>
                <Container>
                    <Row>
                        <Col md={12}>
                            <p className={'p-s'}> {t('products.biomatric_sdk.section_1.para')}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={6} className={'p-0'}>
                            <div className={'sec-1-box green'}>
                                <img src={box1Img} />
                                <h3>{t('products.biomatric_sdk.section_1.box_1.head')}</h3>
                                <p>{t('products.biomatric_sdk.section_1.box_1.para')}</p>
                            </div>
                        </Col>
                        <Col lg={6} className={'p-0'}>
                            <div className={'sec-1-box'}>
                                <img src={box2Img} />
                                <h3>{t('products.biomatric_sdk.section_1.box_2.head')}</h3>
                                <p>{t('products.biomatric_sdk.section_1.box_2.para')}</p>
                            </div>
                        </Col>
                    </Row>
                    <Row className={'flex-column-reverse flex-lg-row'}>
                        <Col lg={6} className={'p-0'}>
                            <div className={'sec-1-box'}>
                                <img src={box3Img} />
                                <h3>{t('products.biomatric_sdk.section_1.box_3.head')}</h3>
                                <p>{t('products.biomatric_sdk.section_1.box_3.para')}</p>
                            </div>
                        </Col>
                        <Col lg={6} className={'p-0'}>
                            <div className={'sec-1-box green'}>
                                <img src={box4Img} />
                                <h3>{t('products.biomatric_sdk.section_1.box_4.head')}</h3>
                                <p>{t('products.biomatric_sdk.section_1.box_4.para')}</p>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={6} className={'p-0'}>
                            <div className={'sec-1-box green'}>
                                <img src={box5Img} />
                                <h3>{t('products.biomatric_sdk.section_1.box_5.head')}</h3>
                                <p>{t('products.biomatric_sdk.section_1.box_5.para')}</p>
                            </div>
                        </Col>
                        <Col lg={6} className={'p-0'}>
                            <div className={'sec-1-box'}>
                                <img src={box6Img} />
                                <h3>{t('products.biomatric_sdk.section_1.box_6.head')}</h3>
                                <p>{t('products.biomatric_sdk.section_1.box_6.para_1')}</p>
                                <p>{t('products.biomatric_sdk.section_1.box_6.para_2')}</p>
                                <p>{t('products.biomatric_sdk.section_1.box_6.para_3')}</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className={activeSection === 2 ? 'section-2' : 'section-2 hide'}>
                <Container>
                    <Row className={'mt-4'}>
                        <Col md={12}>
                            <p>{t('products.biomatric_sdk.section_2.para_1')} </p>
                            <p>{t('products.biomatric_sdk.section_2.para_2')} </p>
                        </Col>
                    </Row>
                    <Row className={'mt-5'}>
                        <Col className={'d-flex align-items-center justify-content-center'} ld={6}>
                            <img src={sec2Img2} className={'img-fluid sec-img mb-5 mb-lg-0'}/>
                        </Col>
                        <Col lg={6}>
                            <p>{t('products.biomatric_sdk.section_2.para_3')} </p>
                        </Col>
                    </Row>
                    <Row className={'mt-5'}>
                        <Col lg={6}>
                            <p>{t('products.biomatric_sdk.section_2.para_4')}  </p>
                            <p>{t('products.biomatric_sdk.section_2.para_5')}</p>
                            <p><b>{t('products.biomatric_sdk.section_2.para_6')}</b></p>
                        </Col>
                        <Col className={'d-flex align-items-center justify-content-center'} lg={6}>
                            <img  src={sec2Img} className={'img-fluid sec-img'} />
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className={activeSection === 3 ? 'section-3' : 'section-3 hide'}>
                <Container>
                    <Row className={'mb-5'}>
                        <Col md={12}>
                            <p>{t('products.biomatric_sdk.section_3.para_1')}</p>
                            <p>{t('products.biomatric_sdk.section_3.para_2')}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={6} xl={7}>
                            <p>{t('products.biomatric_sdk.section_3.para_3')}</p>
                            <p>{t('products.biomatric_sdk.section_3.para_4')}</p>
                            <p>{t('products.biomatric_sdk.section_3.para_5')}</p>
                            <p>{t('products.biomatric_sdk.section_3.para_6')}</p>
                            <p><b>{t('products.biomatric_sdk.section_3.para_7')}</b></p>
                        </Col>
                        <Col lg={6} xl={5} className={'text-center'}>
                            <img src={sec3Img} className={'img-fluid '}/>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className={activeSection === 4 ? 'section-4' : 'section-4 hide'}>
                <Container>
                    <Row className={'mb-5'}>
                        <Col md={12}>
                            <p>{t('products.biomatric_sdk.section_4.para_1')} </p>
                            <p>{t('products.biomatric_sdk.section_4.para_2')}</p>
                            <p>{t('products.biomatric_sdk.section_4.para_3')}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={6} xl={7}>
                            <p>{t('products.biomatric_sdk.section_4.para_4')} </p>
                            <p>{t('products.biomatric_sdk.section_4.para_5')}</p>
                            <p>{t('products.biomatric_sdk.section_4.para_6')}</p>
                            <p><b>{t('products.biomatric_sdk.section_4.para_7')}</b></p>

                        </Col>
                        <Col lg={6} xl={5} className={'text-center'}>
                            <img src={sec4Img} className={'img-fluid sec-img'}/>
                        </Col>
                    </Row>
                </Container>
            </div>

        </div>
    )
}